// Tema chiaro/scuro. Tre stati: «sistema» segue il computer (nessun attributo, decide il
// media query), «chiaro» e «scuro» forzano via data-theme sul tag html. La scelta è una
// preferenza del dispositivo — lo stesso utente può volere scuro sul portatile la sera e
// sistema sul fisso — quindi vive nella memoria del browser, non sul server.

export type Theme = 'system' | 'light' | 'dark'

const KEY = 'kpo.theme'

export function currentTheme(): Theme {
  const saved = localStorage.getItem(KEY)
  return saved === 'light' || saved === 'dark' ? saved : 'system'
}

export function applyTheme(theme: Theme) {
  if (theme === 'system') {
    delete document.documentElement.dataset.theme
    localStorage.removeItem(KEY)
  } else {
    document.documentElement.dataset.theme = theme
    localStorage.setItem(KEY, theme)
  }
}

/** Da chiamare prima del primo render: evita il lampo col tema sbagliato. */
export function initTheme() {
  applyTheme(currentTheme())
}

export const themeLabel: Record<Theme, string> = {
  system: 'Sistema',
  light: 'Chiaro',
  dark: 'Scuro',
}

export function nextTheme(theme: Theme): Theme {
  return theme === 'system' ? 'light' : theme === 'light' ? 'dark' : 'system'
}
